import { makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(() => ({
    input: {
        paddingRight: '60px',
    },
}))
